import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { SchedaIntervento } from '../models/models/pages/scheda-intervento';

@Injectable({ providedIn: 'root' })
export class SchedaInterventoService {
    private baseUrl = `${environment.baseApiUrl}/deviatoio-scheda-interventi`;

    constructor(private http: HttpClient) {}

    // LIST con eventuali parametri
    list(params?: { page?: number; size?: number; sort?: string }): Observable<SchedaIntervento[]> {
        let httpParams = new HttpParams();
        if (params?.page != null) httpParams = httpParams.set('page', params.page);
        if (params?.size != null) httpParams = httpParams.set('size', params.size);
        if (params?.sort) httpParams = httpParams.set('sort', params.sort);

        return this.http.get<SchedaIntervento[]>(this.baseUrl, {
            params: httpParams,
            withCredentials: true
        });
    }

    // GET by id
    get(id: number): Observable<SchedaIntervento> {
        return this.http.get<SchedaIntervento>(`${this.baseUrl}/${id}`, { withCredentials: true });
    }

    // CREATE (POST)
    create(payload: Omit<SchedaIntervento, 'id'>): Observable<SchedaIntervento> {
        return this.http.post<SchedaIntervento>(this.baseUrl, payload, { withCredentials: true });
    }

    // UPDATE completo (PUT)
    update(entity: SchedaIntervento): Observable<SchedaIntervento> {
        return this.http.put<SchedaIntervento>(`${this.baseUrl}/${entity.id}`, entity, { withCredentials: true });
    }

    // PATCH parziale
    partialUpdate(id: number, patch: Partial<SchedaIntervento>): Observable<SchedaIntervento> {
        const headers = new HttpHeaders({ 'Content-Type': 'application/merge-patch+json' });
        return this.http.patch<SchedaIntervento>(`${this.baseUrl}/${id}`, patch, {
            headers,
            withCredentials: true
        });
    }

    // DELETE
    delete(uploadOD: any): Observable<void> {
        return this.http.delete<void>(`${this.baseUrl}/delete`, {
            body: uploadOD
        });
    }

    uploadFoto(interventoId: number, file: File): Observable<any> {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('interventoId', interventoId.toString());

        return this.http.post(`${this.baseUrl}/upload`, formData);
    }

    getFoto(interventoId: number): Observable<Blob> {
        return this.http.get(`${this.baseUrl}/preview/${interventoId}`, { responseType: 'blob' });
    }

    uploadOD(formData: FormData): Observable<any> {
        return this.http.post(`${this.baseUrl}/upload-od`, formData, { responseType: 'text' });
    }

    getFilePreview(uploadOD: any): Observable<Blob> {
        return this.http.post(`${this.baseUrl}/preview-od`, uploadOD, { responseType: 'blob', withCredentials: true });
    }

    getPreviewList(uploadOD: any): Observable<string[]> {
        return this.http.post<string[]>(`${this.baseUrl}/preview-list`, uploadOD, {
            withCredentials: true
        });
    }

    deleteFile(uploadOD: any): Observable<any> {
        return this.http.delete<any>(`${this.baseUrl}/files-delete`, {
            body: uploadOD
        });
    }
}
